<template>

</template>

<script>
export default {
  name: "ClientLocation",

  data() {
    return {
      clientLocation: {
        lat: 0,
        lng: 0
      }
    }
  },

  mounted() {
    this.getClientLocation();
  },

  methods: {
    getClientLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.savePosition);
      }
    },

    savePosition: function (position) {
      this.clientLocation.lat = position.coords.latitude;
      this.clientLocation.lng = position.coords.longitude;

      axios.post('/nl/api/clientlocation', this.clientLocation).then(response => (
          window.location = window.location
      ));
    }
  }
}
</script>